import {
  DtcAddLogoFormValues,
  TextFormValues,
} from '../../../../containers/EmbroideryContainer/types'

export function toInt(val: number | string | undefined): number | undefined {
  if (typeof val === 'string') return parseInt(val)
  return val
}

export const buildTextPreferenceQuery = (values: TextFormValues) => {
  const { firstLine, font, secondLine, textPlacement } = values
  const fontKey = font?.displayName.toUpperCase()!
  const placement = { position: textPlacement?.position!, location: textPlacement?.location! }
  return {
    variables: {
      preferences: {
        firstLine,
        fontKey,
        secondLine,
        placement,
      },
    },
  }
}

export const buildLogoPreferenceQuery = (values: DtcAddLogoFormValues) => {
  const { logoFileId, logoPlacement } = values
  const placement = { position: logoPlacement?.position!, location: logoPlacement?.location! }
  return {
    variables: {
      preferences: {
        defaultLogoId: logoFileId!,
        placement,
      },
    },
  }
}
